let webAuthModulePromise;

export function prefetchAuth0WebAuth() {
  if (typeof window === 'undefined') {
    return Promise.resolve(null);
  }
  if (!webAuthModulePromise) {
    webAuthModulePromise = import('auth0-js').catch((error) => {
      webAuthModulePromise = null;
      throw error;
    });
  }
  return webAuthModulePromise;
}

export async function loadAuth0WebAuth() {
  const auth0Module = await prefetchAuth0WebAuth();
  return auth0Module?.WebAuth || auth0Module?.default?.WebAuth || null;
}
